export enum PortalServiceType {
	CLIENT_PORTAL = 'client_portal',
	// Add other portal types as needed
}

// Lives in /portalInvites
export interface PortalInvite {
	id: string;
	portalService: PortalServiceType;
	/** The ID of the service being shared. For client intake forms, this is the intakeFormId */
	portalServiceId: string;
	matterId: string;
	businessId: string;
	invitees: PortalInvitee[];
	accessMethod: InviteAccessMethod;
	createdAt: number;
	createdBy: string;
	updatedAt: number;
	updatedBy: string;
	expiresAt: number;
	status: PortalInviteStatus;
	statusHistory: {
		status: PortalInviteStatus;
		updatedBy: string;
		updatedAt: number;
	}[];
}

export interface PortalInvitee {
	email: string;
	sentHistory: { sentAt: number; sentBy: string }[];
	/** Auth Id for the client after they have accepted the invite*/
	userId?: string;
	/** Id of client in closer */
	clientId?: string;
	name: string;
	displayName: string;
	isActive: boolean;
	inviteAccepted: boolean;
}

export enum InviteAccessMethod {
	EMAIL = 'email',
	STANDALONE_LINK = 'standalone_link',
}

export enum PortalInviteStatus {
	DRAFT = 'draft',
	ACTIVE = 'active',
	CANCELLED = 'cancelled',
}
